import instance from "../../services/axios"; // Importing the Axios instance

// Defining URIs
const uri = {
  packageList: "/package/get-package",
  packageListId: "/package/get",
  packageListName: "/package/get-package-name",
  packageListDomestic: "package/get-packages/domestic",
  packageListInternational: "package/get-packages/international",
  packagePackageCategory: "package/get-package-theme",
  packageCetogoryListId: "/package/get-theme",
  getPackageDataDestinationId: "/package/get-packages-by-destination",
  destinationListId: "/package/get-destination-name",
  getPackageDataBCategorySlug: "/package/get-package-details",
  getAllPackageList: "/package/all-holiday",
  getTestimonialDataById: "/feedbacks/destination",
};

export const getPackageData = async () => {
  const API_KEY = import.meta.env.VITE_SMT_V2_API_KEY;
  const headers = {
    "api-key": API_KEY,
  };

  try {
    const response = await instance.get(uri.packageList, { headers });
    return response.data;
  } catch (error) {
    console.error("Error fetching package list:", error);
    throw error;
  }
};

export const getPackageDataById = async (id) => {
  const API_KEY = import.meta.env.VITE_SMT_V2_API_KEY;
  const headers = {
    "api-key": API_KEY,
  };

  try {
    const response = await instance.get(`${uri.packageListId}/${id}`, {
      headers,
    });
    return response.data;
  } catch (error) {
    console.error(`Error fetching package data by ID: ${id}`, error);
    throw error?.response?.data || error.message;
  }
};

export const getPackageList = async () => {
  const API_KEY = import.meta.env.VITE_SMT_V2_API_KEY;
  const headers = {
    "api-key": API_KEY,
  };

  try {
    const response = await instance.get(uri.packageListName, {
      headers: headers,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching profile:", error);
    throw error;
  }
};

export const getPackageDomasticData = async () => {
  const API_KEY = import.meta.env.VITE_SMT_V2_API_KEY;
  const headers = {
    "api-key": API_KEY,
  };

  try {
    const response = await instance.get(uri.packageListDomestic, { headers });
    return response.data;
  } catch (error) {
    console.error("Error fetching package list:", error);
    throw error;
  }
};

export const getPackageInternationalData = async () => {
  const API_KEY = import.meta.env.VITE_SMT_V2_API_KEY;
  const headers = {
    "api-key": API_KEY,
  };

  try {
    const response = await instance.get(uri.packageListInternational, {
      headers,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching package list:", error);
    throw error;
  }
};

export const getCategoriesList = async () => {
  const API_KEY = import.meta.env.VITE_SMT_V2_API_KEY;
  const headers = {
    "api-key": API_KEY,
  };

  try {
    const response = await instance.get(uri.packagePackageCategory, {
      headers,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching package list:", error);
    throw error;
  }
};

export const getPackageDataBCategoryId = async (id) => {
  const API_KEY = import.meta.env.VITE_SMT_V2_API_KEY;
  const headers = {
    "api-key": API_KEY,
  };

  try {
    const response = await instance.get(`${uri.packageCetogoryListId}/${id}`, {
      headers,
    });
    return response.data;
  } catch (error) {
    console.error(`Error fetching package data by ID: ${id}`, error);
    throw error?.response?.data || error.message;
  }
};

export const getPackageDataDestinationId = async () => {
  const API_KEY = import.meta.env.VITE_SMT_V2_API_KEY;
  const headers = {
    "api-key": API_KEY,
  };

  try {
    const response = await instance.get(uri.getPackageDataDestinationId, {
      headers,
    });
    return response.data;
  } catch (error) {
    console.error(`Error fetching package data by ID: ${id}`, error);
    throw error?.response?.data || error.message;
  }
};

export const getDestinationListDatabyId = async (cleanedId) => {
  const API_KEY = import.meta.env.VITE_SMT_V2_API_KEY;
  const headers = {
    "api-key": API_KEY,
  };

  try {
    const response = await instance.get(
      `${uri.destinationListId}/${cleanedId}`,
      { headers }
    );
    return response.data;
  } catch (error) {
    console.error(`Error fetching package data by ID: ${id}`, error);
    throw error?.response?.data || error.message;
  }
};

export const getPackageDataBCategorySlug = async (id) => {
  const API_KEY = import.meta.env.VITE_SMT_V2_API_KEY;
  const headers = {
    "api-key": API_KEY,
  };

  try {
    const response = await instance.get(
      `${uri.getPackageDataBCategorySlug}/${id}`,
      { headers }
    );
    return response.data;
  } catch (error) {
    console.error(`Error fetching package data by ID: ${id}`, error);
    throw error?.response?.data || error.message;
  }
};

export const getAllPackageList = async () => {
  const API_KEY = import.meta.env.VITE_SMT_V2_API_KEY;
  const headers = {
    "api-key": API_KEY,
  };

  try {
    const response = await instance.get(uri.getAllPackageList, {
      headers: headers,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching profile:", error);
    throw error;
  }
};

export const getTestimonialDatabyId = async (feedbackType, id) => {
  const API_KEY = import.meta.env.VITE_SMT_V2_API_KEY;
  const headers = {
    "api-key": API_KEY,
  };

  try {
    const response = await instance.get(
      `${uri.getTestimonialDataById}/${feedbackType}/${id}`,
      { headers }
    );
    return response.data;
  } catch (error) {
    console.error(`Error fetching package data by ID: ${id}`, error);
    throw error?.response?.data || error.message;
  }
};
